import { useMutation } from "@tanstack/react-query";
import { accountApi, type ChangePasswordParams } from "@/api/accountApi";

export const usePasswordChange = () =>
  useMutation({
    mutationFn: (params: ChangePasswordParams) =>
      accountApi.changePassword(params),
  });
